// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_TOPICS = "Sp\u00e4\u0165 na f\u00f3ra";
export const FORUM_ARCHIVE_CAMPAIGNS_PAGE_TITLE = "Dni so zna\u010dkou";
export const FORUM_TOPICS_NOT_FOUND_query = "Nena\u0161li sa \u017eiadne f\u00f3ra so slovom \"%(query)s\".";
export const LIST_OF_FORUMS_BLUEHORSE = "Modr\u00fd kon\u00edk";
export const LOAD_PREVIOUS = "Na\u010d\u00edta\u0165 predch\u00e1dzaj\u00face";
export const NEW_FEMININE = "Nov\u00e1";
